import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import { toastConfig } from "react-simple-toasts";
import withClearCache from "./ClearCache";

toastConfig({
  time: 3000,
  //className: 'my-toast-message',
});

const ClearCacheComponent = withClearCache(App);

ReactDOM.render(
  <React.StrictMode>
    <ClearCacheComponent />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
